import React from 'react';
import { languages, Language, useLanguage } from './LanguageContext';

const labels = { fr: 'Langue', en: 'Language', es: 'Idioma', pt: 'Idioma', it: 'Lingua', de: 'Sprache', zh: '语言', ar: 'اللغة' };
export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  return <label className="language-selector" style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
    <span>{labels[language]}</span>
    <select aria-label={labels[language]} value={language} onChange={event => setLanguage(event.target.value as Language)} style={{ maxWidth: '100%', minWidth: 0, padding: '8px', borderRadius: 8, background: 'inherit', color: 'inherit', border: '1px solid currentColor' }}>
      {languages.map(item => <option key={item.code} value={item.code} lang={item.locale} style={{ color: '#20364D', background: '#F9FCFF' }}>{item.name}</option>)}
    </select>
  </label>;
}
